import { HTTP_AP_ListActivityLogs_Request_Filter, HTTP_AP_ListActivityLogs_Request_Sort } from '@api-new/reportingservice';
import { ClientActivityLogTableRowModel } from '@platform/client/pages/client-activity-log-table/models/client-activity-log-table-row.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';

export const clientActivityLogTableFilterDefaults: HTTP_AP_ListActivityLogs_Request_Filter = {
  entityType: null,
  action: null,
  createdAt: null,
  propertyId: null,
  mortgageId: null,
  helpCaseId: null,
  smartSearchId: null,
};

export const clientActivityLogTableRowDefinition = (): TableRowDefinitionModel<
  ClientActivityLogTableRowModel,
  HTTP_AP_ListActivityLogs_Request_Sort
>[] => [
  {
    columnLabel: 'Date',
    columnKey: 'createdAt',
    type: RowDefinitionTypeEnum.DateTimeSince,
    sortKey: 'byCreatedAt',
    width: {
      min: '140px',
      max: '140px',
    },
  },
  {
    columnLabel: 'Action',
    columnKey: 'action',
    type: RowDefinitionTypeEnum.Text,
    sortKey: 'byAction',
    width: {
      min: '100px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Entity type',
    columnKey: 'entityType',
    type: RowDefinitionTypeEnum.Text,
    sortKey: 'byEntityType',
    width: {
      min: '140px',
      max: '240px',
    },
  },
  {
    columnLabel: 'Entity name',
    columnKey: 'entityName',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '140px',
      max: '200px',
    },
  },
  {
    columnLabel: 'Changed by',
    columnKey: 'actionByUserType',
    type: RowDefinitionTypeEnum.Fullname,
    width: {
      min: '140px',
      max: '140px',
    },
  },
  {
    columnLabel: 'Field',
    columnKey: 'fieldName',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '140px',
      max: '240px',
    },
  },
  {
    columnLabel: 'Changed from',
    columnKey: 'changedFrom',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '140px',
      max: '200px',
    },
  },
  {
    columnLabel: 'Changed to',
    columnKey: 'changedTo',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '140px',
      max: '200px',
    },
  },
];
